import axios from 'axios';
import { AuthService } from './AuthService';
import { API_URL } from '../config';
// Configuração base do axios
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// Interceptor para adicionar o token em todas as requisições
axiosInstance.interceptors.request.use(
  (config) => {
    const token = AuthService.getToken();
    console.log('Interceptor - Token disponível:', token);

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      console.log('Interceptor - Headers configurados:', config.headers);
    } else {
      console.log('Interceptor - Token não encontrado');
    }

    return config;
  },
  (error) => {
    console.error('Interceptor - Erro na requisição:', error);
    return Promise.reject(error);
  }
);

// Interceptor para tratar erros de autenticação
axiosInstance.interceptors.response.use(
  (response) => {
    console.log('Interceptor - Resposta recebida:', response.status);
    return response;
  },
  (error) => {
    console.error('Interceptor - Erro na resposta:', error.response?.status);

    if (error.response?.status === 401) {
      console.log('Interceptor - Token expirado ou inválido');
      AuthService.logout();
      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);

export default axiosInstance; 